import { App as Nove8App } from 'nove8/App'
import React from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './styles.css'

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    // Facebook Pixel
    fbq: any
    // ZenDesk plugin
    zE: any
    zESettings: any
    // Google analytics
    gtag: any
    MSStream: any
    // TikTok Pixel
    ttq: any
    // Snap Pixel
    snaptr: any
    // UET Tag Code
    uetq: any
    // Pinterest Tag Code
    pintrk: any
    dataLayer: any
    axon: any
    // Cookieyes Tag Code
    cookieyes: any
    getCkyConsent: () => {
      activeLaw: string
      isUserActionCompleted: boolean
    }
  }
}

const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <>
    {/* <Partytown
      forward={[
        // Disabled because of the errors in applovin(axon) pixel events
        // 'dataLayer.push',
        // 'gtag',
        // 'axon',
        'fbq',
        'snaptr',
        'uetq.push',
        'ttq.identify',
        'ttq.track',
        'ttq.page',
        'ttq.load',
      ]}
      globalFns={['UET']}
      resolveUrl={(url, location, type) => {
        const REVERSE_PROXY_ORIGIN = 'https://reverse-proxy.supernove8.com'

        if (type === 'script' && url.origin !== REVERSE_PROXY_ORIGIN) {
          const proxyUrl = new URL(REVERSE_PROXY_ORIGIN)
          proxyUrl.searchParams.append('proxiedUrl', url.href)
          return proxyUrl
        }

        return url
      }}
    /> */}
    <Nove8App />
  </>,
)
